var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutubeDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 310,
    zoomAndPan: "magnify",
    viewBox: "0 0 232.5 232.499992",
    height: 310,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "cd097700df"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 34 L 232 34 L 232 199 L 0 199 Z M 0 34 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cd097700df)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#211608",
    d: "M 223.4375 48.484375 C 215.046875 38.507812 199.550781 34.4375 169.957031 34.4375 L 62.539062 34.4375 C 32.269531 34.4375 16.511719 38.769531 8.152344 49.390625 C 0 59.746094 0 75.007812 0 96.125 L 0 136.375 C 0 177.289062 9.671875 198.0625 62.539062 198.0625 L 169.957031 198.0625 C 195.621094 198.0625 209.839844 194.472656 219.039062 185.667969 C 228.476562 176.636719 232.5 161.898438 232.5 136.375 L 232.5 96.125 C 232.5 73.851562 231.871094 58.503906 223.4375 48.484375 Z M 149.265625 121.808594 L 100.488281 147.300781 C 99.398438 147.871094 98.203125 148.152344 97.011719 148.152344 C 95.664062 148.152344 94.320312 147.789062 93.128906 147.070312 C 90.882812 145.710938 89.511719 143.277344 89.511719 140.652344 L 89.511719 89.832031 C 89.511719 87.210938 90.878906 84.78125 93.121094 83.421875 C 95.359375 82.058594 98.144531 81.96875 100.46875 83.175781 L 149.25 108.503906 C 151.730469 109.792969 153.289062 112.355469 153.292969 115.148438 C 153.296875 117.945312 151.742188 120.511719 149.265625 121.808594 Z M 149.265625 121.808594 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeDark);
export default __webpack_public_path__ + "static/media/youtubeDark.8d94ca5bcb152b650778ecc919e4006a.svg";
export { ForwardRef as ReactComponent };